import { put, select } from "redux-saga/effects";

import { initiateCreateModeFulfilled, resetCreateMap } from "domains/createMapDetail/actions";
import type { TransformationMapSetEditModeAction } from "domains/transformationMap/actionTypes";
import { getTmTopic } from "domains/transformationMap/selectors";
import { router } from "router/router";

export function* setEditModeSaga({ meta }: TransformationMapSetEditModeAction) {
  const { mode } = meta;
  if (mode) {
    const topic: ReturnType<typeof getTmTopic> = yield select(getTmTopic);
    if (topic) {
      yield put(initiateCreateModeFulfilled(topic));
      yield router.navigate(topic.can_edit ? "?editing=true" : "/create");
    }
  } else {
    yield put(resetCreateMap());
    // Save map before setting
  }
}
